// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Design Tokens ──────────────────────────────────────────────────────── */
:root {
  /* Typography */
  --font-mono:    'IBM Plex Mono', monospace;
  --font-sans:    'Open Sans', sans-serif;

  /* Background */
  --color-bg:     #0d0d0f;
  --color-bg-sub: #111114;
  --color-bg-row: #14141a;

  /* Borders */
  --color-border: #1a1a20;

  /* Text */
  --color-text:   #ccc;
  --color-muted:  #888;
  --color-dim:    #555;
  --color-white:  #fff;

  /* Accent */
  --color-accent: #00d97e;
  --color-blue:   #00a8ff;
  --color-danger: #ff4757;

  /* Gradients */
  --gradient-accent:  linear-gradient(135deg, var(--color-accent), var(--color-blue));
  --gradient-slider:  linear-gradient(90deg,  var(--color-accent), var(--color-blue));
  --gradient-scroll:  linear-gradient(180deg, var(--color-accent), var(--color-blue));
  --gradient-danger:  linear-gradient(135deg, var(--color-danger), #ff6b7a);
}

/* ─── Base ───────────────────────────────────────────────────────────────── */
* {
  box-sizing: border-box;
}

html {
  font-family: var(--font-mono);
}

body {
  margin: 0;
  background: #ffffff;
  font-family: var(--font-mono);
}

/* ─── Utilities ──────────────────────────────────────────────────────────── */
.center {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ─── Route transitions ──────────────────────────────────────────────────── */
.slide-in-left-enter         { transform: translateX(-100%); }
.slide-in-left-enter-active  { transform: translateX(0); opacity: 1; transition: all 200ms; }
.slide-in-left-exit          { transform: translateX(0%); opacity: 1; }
.slide-in-left-exit-active   { transform: translateX(-100%); opacity: 0; transition: all 200ms; }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA,+EAA+E;AAC/E;EACE,eAAe;EACf,0CAA0C;EAC1C,uCAAuC;;EAEvC,eAAe;EACf,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,YAAY;EACZ,uBAAuB;;EAEvB,SAAS;EACT,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;;EAEvB,cAAc;EACd,mFAAmF;EACnF,mFAAmF;EACnF,mFAAmF;EACnF,yEAAyE;AAC3E;;AAEA,+EAA+E;AAC/E;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E,+BAA+B,4BAA4B,EAAE;AAC7D,+BAA+B,wBAAwB,EAAE,UAAU,EAAE,qBAAqB,EAAE;AAC5F,+BAA+B,yBAAyB,EAAE,UAAU,EAAE;AACtE,+BAA+B,4BAA4B,EAAE,UAAU,EAAE,qBAAqB,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600;700&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap');\n\n/* ─── Design Tokens ──────────────────────────────────────────────────────── */\n:root {\n  /* Typography */\n  --font-mono:    'IBM Plex Mono', monospace;\n  --font-sans:    'Open Sans', sans-serif;\n\n  /* Background */\n  --color-bg:     #0d0d0f;\n  --color-bg-sub: #111114;\n  --color-bg-row: #14141a;\n\n  /* Borders */\n  --color-border: #1a1a20;\n\n  /* Text */\n  --color-text:   #ccc;\n  --color-muted:  #888;\n  --color-dim:    #555;\n  --color-white:  #fff;\n\n  /* Accent */\n  --color-accent: #00d97e;\n  --color-blue:   #00a8ff;\n  --color-danger: #ff4757;\n\n  /* Gradients */\n  --gradient-accent:  linear-gradient(135deg, var(--color-accent), var(--color-blue));\n  --gradient-slider:  linear-gradient(90deg,  var(--color-accent), var(--color-blue));\n  --gradient-scroll:  linear-gradient(180deg, var(--color-accent), var(--color-blue));\n  --gradient-danger:  linear-gradient(135deg, var(--color-danger), #ff6b7a);\n}\n\n/* ─── Base ───────────────────────────────────────────────────────────────── */\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: var(--font-mono);\n}\n\nbody {\n  margin: 0;\n  background: #ffffff;\n  font-family: var(--font-mono);\n}\n\n/* ─── Utilities ──────────────────────────────────────────────────────────── */\n.center {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* ─── Route transitions ──────────────────────────────────────────────────── */\n.slide-in-left-enter         { transform: translateX(-100%); }\n.slide-in-left-enter-active  { transform: translateX(0); opacity: 1; transition: all 200ms; }\n.slide-in-left-exit          { transform: translateX(0%); opacity: 1; }\n.slide-in-left-exit-active   { transform: translateX(-100%); opacity: 0; transition: all 200ms; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
